"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackedGond = exports.NormGond = exports.TrackedSC = exports.NormSC = exports.TrackedTram = exports.NormTram = exports.TrackedRail = exports.NormRail = exports.TrackedBus = exports.NormBus = exports.TrackedShape = exports.Shape = exports.tracked = exports.normal = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Circle = require("@styled-icons/fa-solid/Circle");

var _icons = require("@opentripplanner/icons");

var utils = _interopRequireWildcard(require("../../../utils"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// note: want to make these props of styled, so props.colorselected
// BTW, 'props.color' works, since that's an established prop of styled
// https://stackoverflow.com/questions/52321539/react-passing-props-with-styled-components
const white = "#fff";
const black = "#000";
const defColor = black;
const defSelected = "#00bfff";
const normal = (0, _styledComponents.css)(["color:", ";fill:", ";border:1px solid ", ";background-color:", ";:hover{fill:", " !important;color:", ";background-color:", ";border:1px solid ", ";}border-radius:50%;display:block;margin-left:auto;margin-right:auto;"], props => props.color || defColor, props => props.color || defColor, props => props.color || defColor, white, black, props => props.colorselected || defSelected, props => props.colorselected || defSelected, black);
exports.normal = normal;
const tracked = (0, _styledComponents.css)(["fill:", " !important;color:", ";border:1px solid ", ";background-color:", ";"], black, props => props.colorselected || defSelected, black, props => props.colorselected || defSelected);
exports.tracked = tracked;
const Shape = (0, _styledComponents.default)(_Circle.Circle).withConfig({
  displayName: "styled__Shape",
  componentId: "qbpsr0-0"
})(["", " background-color:", ";"], normal, props => props.color || defColor);
exports.Shape = Shape;
const TrackedShape = (0, _styledComponents.default)(Shape).withConfig({
  displayName: "styled__TrackedShape",
  componentId: "qbpsr0-1"
})(["", ""], tracked);
exports.TrackedShape = TrackedShape;
const [NormBus, TrackedBus, NormRail, TrackedRail, NormTram, TrackedTram, NormSC, TrackedSC, NormGond, TrackedGond] = utils.makeModeStyles(normal, tracked, _icons.Bus, _icons.Wes, _icons.Max, _icons.Streetcar, _icons.AerialTram);
exports.TrackedGond = TrackedGond;
exports.NormGond = NormGond;
exports.TrackedSC = TrackedSC;
exports.NormSC = NormSC;
exports.TrackedTram = TrackedTram;
exports.NormTram = NormTram;
exports.TrackedRail = TrackedRail;
exports.NormRail = NormRail;
exports.TrackedBus = TrackedBus;
exports.NormBus = NormBus;
//# sourceMappingURL=styled.js.map